"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __await = (this && this.__await) || function (v) { return this instanceof __await ? (this.v = v, this) : new __await(v); }
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
var __asyncDelegator = (this && this.__asyncDelegator) || function (o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
};
var __asyncGenerator = (this && this.__asyncGenerator) || function (thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkyModService = void 0;
const resources_1 = require("../model/resources");
const path_1 = require("../model/path");
const resources_2 = require("../model/resources");
const constants_1 = require("../constants");
const React = __importStar(require("react"));
const skymod_1 = require("@oxfordeconomics/skymod");
const economic_forecasting_1 = require("@oxfordeconomics/economic-forecasting");
const utilities_1 = require("../utilities");
const cancellable = __importStar(require("../model/cancellable"));
class SkyModClientWithCaching extends skymod_1.SkyModClient {
    constructor(url, jwt) {
        super(url, () => jwt);
        this.cachedDomains = super.domain_GetAll();
    }
    domain_GetAll() {
        return this.cachedDomains;
    }
}
class SkyModService {
    constructor(url, jwt) {
        this.client = new SkyModClientWithCaching(url, jwt);
    }
    uploadResource(directory, file) {
        return new SkyModUpload(directory, file, this.client);
    }
    getResource(path) {
        return __awaiter(this, void 0, void 0, function* () {
            const resource = yield this.client.resource_Get(path.Value, true); // must explicitly request all file types
            return MapResource(resource, this.client);
        });
    }
    getPlaces() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let clientPlaces = yield this.client.place_ListAll();
                const returnPlaces = clientPlaces.map(place => {
                    if (IsFolderPlace(place)) {
                        return new SkyModFolderPlace(place, this.client);
                    }
                    else {
                        // Admin-only places such as users/organizations list resources but have no folder of their own
                        return new SkyModListingPlace(place, this.client);
                    }
                });
                return returnPlaces;
            }
            catch (error) {
                if (IsFailedToFetch(error)) {
                    throw new SkyModApiError("API unavailable", error);
                }
                else {
                    throw error;
                }
            }
        });
    }
    createFolder(path) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.client.resource_Put(path.Value);
            return new SkyModServiceFolder(result, this.client);
        });
    }
}
exports.SkyModService = SkyModService;
function IsFailedToFetch(error) {
    return error && error instanceof Error && error.message === "Failed to fetch";
}
class SkyModApiError extends Error {
    constructor(message, innerError) {
        super(message);
        this.innerError = innerError;
    }
}
function HasChildren(resource) {
    const childrenProp = "Children";
    return resource.ResourceType === skymod_1.ResourceType.Directory
        && !!resource[childrenProp];
}
function IsGenericFile(resource) {
    return resource.ResourceType === skymod_1.ResourceType.OtherFile;
}
function IsForecast(resource) {
    return resource.ResourceType === skymod_1.ResourceType.Forecast;
}
function IsFolderPlace(place) {
    return place["Type"] === "DirectoryPlaceListing";
}
class SkyModServiceResourceFile extends resources_1.ResourceFile {
    constructor(source, client) {
        super(new path_1.Path(source.Path), source.Id, source.Versions.map(apiVersion => ({
            Id: apiVersion.Id,
            Version: apiVersion.Version,
            CreatedAt: new Date(apiVersion.CreatedAt)
        })), MapApiArchiving(source.Archiving), source.FileType, source.MimeType);
        this.source = source;
        this.client = client;
    }
    GetDownloadUrl() {
        return GetDownloadUrl(this.client, this);
    }
    getArchiveOp() {
        // Item can be archived unless it already has archiving props
        if (this.source.Archiving) {
            return null;
        }
        else {
            return () => __awaiter(this, void 0, void 0, function* () {
                const result = yield this.client.resource_MoveToArchiveAsync(`=${this.source.Id}`);
            });
        }
    }
    getDeleteOp() {
        // Item can only be deleted if it's in the archive
        if (this.source.Archiving) {
            return () => __awaiter(this, void 0, void 0, function* () {
                yield this.client.resource_Delete(this.Path.Value);
            });
        }
        else {
            return null;
        }
    }
    getRenameOp() {
        return (newName) => __awaiter(this, void 0, void 0, function* () {
            const result = yield this.client.resource_Patch({ Name: newName, Directory: null, ArchiveAction: null, Product: null }, `=${this.source.Id}`);
        });
    }
    getRestoreOp() {
        // Item can be archived if it has archiving props
        if (this.source.Archiving) {
            return () => __awaiter(this, void 0, void 0, function* () {
                const result = yield this.client.resource_RestoreFromArchiveAsync(`=${this.source.Id}`);
            });
        }
        else {
            return null;
        }
    }
}
function MapResource(resource, client) {
    return __awaiter(this, void 0, void 0, function* () {
        if (resource.ResourceType === skymod_1.ResourceType.Directory) {
            return new SkyModServiceFolder(resource, client);
        }
        else if (IsForecast(resource)) {
            const domains = yield client.domain_GetAll();
            const domain = domains.find(availableDomain => availableDomain.Code.toLowerCase() == resource.EconomicDomain.toLowerCase())
                || { Code: "Unknown", Name: "Unknown", IconUrl: null };
            return new SkyModServiceForecast(resource, client, domain);
        }
        else if ((IsGenericFile(resource))) {
            return new SkyModServiceResourceFile(resource, client);
        }
        else {
            throw new Error(`Unrecognized SkyMod resource type: ${JSON.stringify(resource)}`);
        }
    });
}
class SkyModServiceForecast extends resources_2.Forecast {
    constructor(source, client, domain) {
        super(new path_1.Path(source.Path), source.Id, source.Versions.map(skyModVersion => ({
            Id: skyModVersion.Id,
            Name: skyModVersion.Name,
            Version: skyModVersion.Version,
            CreatedAt: new Date(skyModVersion.CreatedAt),
            EconomicDomain: domain,
            Range: {
                From: economic_forecasting_1.PeriodHelper.Parse(skyModVersion.Range.From),
                To: economic_forecasting_1.PeriodHelper.Parse(skyModVersion.Range.To)
            }
        })), MapApiArchiving(source.Archiving));
        this.source = source;
        this.client = client;
    }
    GetDownloadUrl() {
        return GetDownloadUrl(this.client, this);
    }
    getArchiveOp() {
        // Item can be archived unless it already has archiving props
        if (this.source.Archiving) {
            return null;
        }
        else {
            return () => __awaiter(this, void 0, void 0, function* () {
                const result = yield this.client.resource_MoveToArchiveAsync(`=${this.source.Id}`);
            });
        }
    }
    getDeleteOp() {
        // Item can only be deleted if it's in the archive
        if (this.source.Archiving) {
            return () => __awaiter(this, void 0, void 0, function* () {
                yield this.client.resource_Delete(this.Path.Value);
            });
        }
        else {
            return null;
        }
    }
    getRenameOp() {
        return (newName) => __awaiter(this, void 0, void 0, function* () {
            const result = yield this.client.resource_Patch({ Name: newName, Directory: null, ArchiveAction: null, Product: null }, `=${this.source.Id}`);
        });
    }
    getRestoreOp() {
        // Item can be archived if it has archiving props
        if (this.source.Archiving) {
            return () => __awaiter(this, void 0, void 0, function* () {
                const result = yield this.client.resource_RestoreFromArchiveAsync(`=${this.source.Id}`);
            });
        }
        else {
            return null;
        }
    }
}
function GetDomainName(code) {
    switch (code.toLowerCase()) {
        case "macro": return "Global Economic Model";
        case "industry": return "Global Industry Model";
        default: return null;
    }
}
class SkyModServiceFolderBase {
    constructor(Path, client) {
        this.Path = Path;
        this.client = client;
    }
    get Type() { return resources_2.ResourceTypes.Folder; }
    GetChildren() {
        return __awaiter(this, void 0, void 0, function* () {
            const fullDirectory = (yield this.client.resource_Get(this.Path.Value, true)); // must explicitly request all file types
            return yield Promise.all(fullDirectory.Children.map(clientResource => MapResource(clientResource, this.client)));
        });
    }
    get Move() {
        return (newChildren) => __awaiter(this, void 0, void 0, function* () {
            for (const child of newChildren) {
                if (child instanceof SkyModServiceFolder || child instanceof SkyModServiceForecast || child instanceof SkyModServiceResourceFile) {
                    yield this.client.resource_Patch({ Name: null, Directory: this.Path.Value, ArchiveAction: null, Product: null }, `=${child.Id}`);
                }
                else {
                    throw new Error(`Unexpected resource type to move: ${child.Type}`);
                }
            }
        });
    }
    get InsertCopy() {
        const copyOne = (resource, targetFolder) => __awaiter(this, void 0, void 0, function* () {
            if (resource instanceof SkyModServiceForecast || resource instanceof SkyModServiceResourceFile) {
                yield this.client.resource_Copy(`=${resource.Id}`, { Directory: targetFolder.Value });
            }
            else if (resource.Type === resources_2.ResourceTypes.Folder) {
                // Ensure there is at least an empty folder
                yield this.client.resource_Put(targetFolder.Concat(resource.Path.Name).Value);
            }
            else {
                throw new Error(`Unexpected resource type to copy: ${resource.Type}`);
            }
        });
        return (resources) => __awaiter(this, void 0, void 0, function* () {
            for (const resource of resources) {
                if (resource instanceof SkyModServiceForecast || resource instanceof SkyModServiceResourceFile) {
                    yield copyOne(resource, this.Path);
                }
                else if (resource instanceof SkyModServiceFolder) {
                    // Recursively copying a folder is potentially a big deal
                    // Arbitrarily limit total number of descendents which can be copied
                    const limit = 100;
                    if (yield utilities_1.HasGreaterThan(GetAllDescendents(resource), limit)) {
                        throw new Error(`Cannot copy folders with more than ${limit} items (including items in subfolders)`);
                    }
                    yield copyOne(resource, this.Path);
                    yield CopyChildrenRecursive(resource, this.Path.Concat(resource.Path.Name), copyOne);
                }
                else {
                    throw new Error(`Unexpected resource type to move: ${resource.Type}`);
                }
            }
        });
    }
}
function MapApiArchiving(source) {
    return !!source
        ? { At: new Date(source.ArchivedAt), From: new path_1.Path(source.ArchivedFrom) }
        : null;
}
class SkyModServiceFolder extends SkyModServiceFolderBase {
    constructor(source, client) {
        super(new path_1.Path(source.Path), client);
        this.source = source;
    }
    get FileType() { return ""; }
    get Archived() {
        return MapApiArchiving(this.source.Archiving);
    }
    get Id() { return this.source.Id; }
    get Delete() {
        // Item can only be deleted if it's in the archive
        if (this.source.Archiving) {
            return () => __awaiter(this, void 0, void 0, function* () {
                yield this.client.resource_Delete(this.Path.Value);
            });
        }
        else {
            return null;
        }
    }
    get Rename() {
        return (newName) => __awaiter(this, void 0, void 0, function* () {
            const result = yield this.client.resource_Patch({ Name: newName, Directory: null, ArchiveAction: null, Product: null }, `=${this.source.Id}`);
        });
    }
    get Archive() {
        // Item can be archived unless it already has archiving props
        if (this.source.Archiving) {
            return null;
        }
        else {
            return () => __awaiter(this, void 0, void 0, function* () {
                const result = yield this.client.resource_MoveToArchiveAsync(`=${this.source.Id}`);
            });
        }
    }
    get Restore() {
        // Item can be archived if it has archiving props
        if (this.source.Archiving) {
            return () => __awaiter(this, void 0, void 0, function* () {
                const result = yield this.client.resource_RestoreFromArchiveAsync(`=${this.source.Id}`);
            });
        }
        else {
            return null;
        }
    }
}
function GetAllDescendents(folder) {
    return __asyncGenerator(this, arguments, function* GetAllDescendents_1() {
        const children = yield __await(folder.GetChildren());
        for (const child of children) {
            yield yield __await(child);
            if (child.Type === resources_2.ResourceTypes.Folder) {
                yield __await(yield* __asyncDelegator(__asyncValues(GetAllDescendents(child))));
            }
        }
    });
}
function CopyChildrenRecursive(folder, targetFolder, copyOne) {
    return __awaiter(this, void 0, void 0, function* () {
        const children = yield folder.GetChildren();
        for (const child of children) {
            yield copyOne(child, targetFolder);
            if (child.Type === resources_2.ResourceTypes.Folder) {
                yield CopyChildrenRecursive(child, targetFolder.Concat(child.Path.Name), copyOne);
            }
        }
    });
}
function MapPlaceType(place) {
    switch (place.Code.toLowerCase()) {
        case "me": return "MyResources";
        case "us": return "OurResources";
        case "releases": return "Releases";
        case "my-archive": return "MyArchive";
        default:
            console.warn(`Unrecognized place code in SkyMod '${place.Code}'`);
            return null;
    }
}
class SkyModFolderPlace extends SkyModServiceFolderBase {
    constructor(source, client) {
        super(new path_1.Path(source.Path), client);
        this.source = source;
    }
    get Name() { return this.source.Name; }
    get Code() { return this.source.Code; }
    get PlaceType() { return MapPlaceType(this.source); }
    // No modifications to folder itself
    get Archive() { return null; }
    get Delete() { return null; }
    get Rename() { return null; }
    get Restore() { return null; }
    get Archived() { return null; }
}
function MapListingPlaceType(place) {
    switch (place.Code.toLowerCase()) {
        case "users": return "AllUsers";
        case "organizations": return "AllOrganizations";
        default:
            throw new Error(`Unsupported place type: ${JSON.stringify(place)}`);
    }
}
// A place which is just a list of resources, not backed by a single folder
class SkyModListingPlace {
    constructor(source, client) {
        this.source = source;
        this.client = client;
    }
    get Type() { return "Virtual"; }
    get Name() { return this.source.Name; }
    get Code() { return this.source.Code; }
    get PlaceType() { return MapListingPlaceType(this.source); }
    GetChildren() {
        return __awaiter(this, void 0, void 0, function* () {
            const place = yield this.client.place_Get(this.source.Code);
            return yield Promise.all(place.Resources.map(resource => MapResource(resource, this.client)));
        });
    }
}
function GetDownloadUrl(client, source) {
    return client.file_GetDownloadUrl(`=${source.Id}`, source.Versions[source.Versions.length - 1].Version, 30000);
}
class SkyModUpload {
    constructor(target, file, client) {
        this.progress = 0;
        this.onProgressHandlers = [];
        this.Name = constants_1.FileExtensions.Forecast.RemoveFrom(file.name); // Convention is for forecasts not to have extension
        const { token: cancellationToken, cancel } = skymod_1.CancellationToken.Create();
        if (constants_1.FileExtensions.Db.Matches(file.name)) {
            this.Complete = Promise.resolve(cancellable.Failed(React.createElement("p", null,
                React.createElement("span", { className: "file-ext" }, ".db"),
                " files are not directly supported in Global Model Workstation Online. Please convert your file into a ",
                React.createElement("span", { className: "file-ext" }, ".3f"),
                " file, following the instructions",
                React.createElement("a", { href: "https://support.oxfordeconomics.com/a/solutions/articles/52000034670", target: "_blank", rel: "noopener noreferrer" }, " here."))));
        }
        else {
            this.Complete = client.file_UploadTus({
                destinationDirectory: target.Value,
                file,
                filename: this.Name,
                progressReporter: (bytesSent, bytesTotal) => {
                    const tusProgress = bytesTotal > 0 ? bytesSent / bytesTotal : 0;
                    // Progress reported by tus does not include some operations which occur after the file reaches the API
                    // such as validation and persistence to cloud storage.
                    // Let's say, somewhat arbitrarily, that the tus bit is about 90% of the total duration
                    // After that, progress will stick until the upload is complete.
                    const tusProgressProportion = 0.9;
                    this.updateProgress(tusProgress * tusProgressProportion);
                },
                cancellationToken
            }).then(skymodResult => skymodResult === "Completed"
                ? cancellable.Succeeded()
                : skymodResult === "Cancelled"
                    ? cancellable.Cancelled()
                    : utilities_1.HandleNever(skymodResult, "Upload result"), (error) => {
                return cancellable.Failed(`${error.originalResponse.getBody()}`);
            });
        }
        this.Name = file.name;
        this.Cancel = cancel;
    }
    get CurrentProgress() { return this.progress; }
    OnProgress(handler) {
        this.onProgressHandlers.push(handler);
    }
    updateProgress(value) {
        this.progress = value;
        for (const onProgress of this.onProgressHandlers) {
            onProgress(value);
        }
    }
}
//# sourceMappingURL=skymod-service.js.map